<template>
    <form  class="upload">
        <input
            id="upload"
            type="file"
            accept="image/*"
            action="http://192.168.0.1:3000"
            method="post"
            @change="onFileChange"
        />
    </form >
</template>

<script>

export default {
  props: ['onFileChange'],
  name: 'Upload'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.upload {
    display: none;
}
.upload input {

}
</style>


// WEBPACK FOOTER //
// src/components/comm/Upload.vue